import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ButtonHeading, CommonInput, CommonModal, CustomPagination, CustomSelect, InvoiceStepperComponent } from 'components'
import { UserContext } from 'context';
import { claimDeleteForSummaryDetails, getClaimListForInoviceDetailsTab, getDetailsOfSummaryData, getListDataForSelectClaims } from '_services/invoiceBillRaiseServices';
import StorageService from 'utils/StorageServices/StorageServices';
import { AddEditLrModal, ConfirmModalFor, LrDetailModal } from 'modals';
import { utils } from 'helper';
import BootstrapTable from 'components/BootstrapTable';
import { FaRegTrashCan } from 'react-icons/fa6';
import toast from 'react-hot-toast'
import './invoicing.css'

const ClaimDetailsTabList = (props) => {
    let { filterData, detailsData, callInvoiceDetailsApi = () => { } } = props;
    const navigate = useNavigate();
    const { type, id } = useParams();

    const [lrDeleteConfirm, setLrDeleteConfirm] = useState(false);
    const [loadingLrDelete, setLoadingLrDelete] = useState(false);

    // const [claimDataList, setClaimDataList] = useState([])
    // const [loading, setLoading] = useState(false);

    // const itemsPerPage = 25;
    // const [totalItems, setTotalItems] = useState(0);
    // const [filter, setFilter] = useState({
    //     limit: 25,
    //     offset: 1,
    //     search: '',
    //     select_claim_ids: []
    // });

    // const claimListInvoiceDetailsTab = async () => {
    //     setLoading(true);
    //     try {
    //         let object = {
    //             company_id: StorageService.getCompanyId(),
    //             billraise_id: id,
    //         }
    //         const res = await getClaimListForInoviceDetailsTab(object);
    //         if (res?.responseCode == 200) {
    //             setClaimDataList(res?.data?.list);
    //             setLoading(false);
    //         } else {
    //             setLoading(false);
    //         }
    //     } catch (error) {
    //         setLoading(false);
    //         // throw error;
    //     }
    // }

    // useEffect(() => {
    //     claimListInvoiceDetailsTab();
    // }, [])

    const columns = [
        { header: "", accessor: "delete" },
        { header: "Claim Name", accessor: "claim_name" },
        { header: "Voucher No.", accessor: "voucher_no" },
        { header: "Invoice Number", accessor: "invoice_number" },
        { header: "From Account", accessor: "from_account" },
        { header: "To Account", accessor: "to_account" },
        { header: "Party", accessor: "consignor_id" },
        { header: "Branch", accessor: "branch" },
        { header: "Invoice Date", accessor: "invoice_date" },
        { header: "Description", accessor: "description" },
        { header: "Total Amount", accessor: "invoice_amount" },
        // { header: "Balance", accessor: "balance" },
        // { header: "Due Date", accessor: "due_date" },
        // { header: "Actions", accessor: "action" },
        // { header: "LR Number", accessor: "lr_number" },
        // { header: "Party Name", accessor: "party_name" },
        // { header: "Claim Name", accessor: "claim_name" },
        // { header: "Amount", accessor: "amount" },
        // { header: "", accessor: "serial" },
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            delete: <span
                className="_del_lrM_btn _avPointer"
                onClick={() => setLrDeleteConfirm(item)}
            >
                <FaRegTrashCan className="del_lrCion" />
                <span>Delete</span>
            </span>,
            claim_name: <>{item?.type_name ? `${item?.type_name} (${item?.sub_type_name})` : '-'}</>,
            voucher_no: <>{item?.voucher_no ? item?.voucher_no : '-'}</>,
            from_account: <>{item?.from_account?.name ? item?.from_account?.name : '-'}</>,
            to_account: <>{item?.to_account?.name ? item?.to_account?.name : '-'}</>,
            invoice_number: <>{item?.invoice_number ? item?.invoice_number : (item?.tags?.billraise?.invoice_number ? item?.tags?.billraise?.invoice_number : '-')}</>,
            invoice_date: <>{item?.invoice_date ? utils.formateDateCalander(item?.invoice_date) : '-'}</>,
            // lr_number: <>{item?.lr_number ? item?.lr_number : '-'}</>,
            consignor_id: <>{item?.consignor_id?.name ? item?.consignor_id?.name : '-'}</>,
            branch: <>{item?.branch_id?.branch ? item?.branch_id?.branch : '-'}</>,
            description: <>{item?.description ? item?.description : '-'}</>,
            invoice_amount: <> {item?.total_amount ? <> &#x20B9; {item?.total_amount} </> : '-'} </>,
        }));
    };

    // const handlePageChange = (page) => {
    //     setFilter((s) => ({ ...s, offset: page }))
    // };

    const submitLrDeleteHandler = async () => {
        setLoadingLrDelete(true);
        try {
            let array = lrDeleteConfirm?._id ? [lrDeleteConfirm?._id] : [];
            let object = {
                company_id: StorageService.getCompanyId(),
                billraise_id: lrDeleteConfirm?.billraise,
                select_claim_ids: array,
            }
            const res = await claimDeleteForSummaryDetails(object);
            if (res?.responseCode == 200) {
                callInvoiceDetailsApi();
                if (res?.responseMessage) {
                    toast.success(`${res?.responseMessage}`);
                }
                setLoadingLrDelete(false);
                setLrDeleteConfirm(false)
            } else {
                if (res?.responseMessage) {
                    toast.success(`${res?.responseMessage}`);
                }
                setLoadingLrDelete(false);
            }
        } catch (error) {
            setLoadingLrDelete(false);
        }
    }

    let confirmObject = {
        isOpen: lrDeleteConfirm,
        closeModal: (e) => setLrDeleteConfirm(false),
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitLrDeleteHandler,
        isLoadding: loadingLrDelete,
    }

    return (
        <>
            <div className="_fleX_inds _blRaise_fits">
                <div className="_divForth">
                    <CommonInput
                        type="text"
                        placeholder="Party Name"
                        label="Party Name"
                        name='name'
                        value={filterData?.consignor_id?.label ? filterData?.consignor_id?.label : ''}
                        disabled={true}
                    />
                </div>
            </div>

            <div className='_tabWith_invoiceTab'>
                <BootstrapTable
                    columns={columns}
                    data={rowListData(detailsData?.claim_list?.length > 0 ? detailsData?.claim_list : [])}
                // isLoading={loading}
                />
                {/* {detailsData?.claim_list?.length > 0 &&
                    <div className='paginationFt_avt '>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>} */}
            </div>
            {
                lrDeleteConfirm?._id && (
                    <CommonModal {...confirmObject}>
                        <p className='p-3'> Are you sure you want to delete claim ? </p>
                    </CommonModal>
                )
            }
        </>
    )
}

export default ClaimDetailsTabList